import { render, staticRenderFns } from "./FloatButtons.vue?vue&type=template&id=6f2ee956&scoped=true"
import script from "./FloatButtons.vue?vue&type=script&lang=js"
export * from "./FloatButtons.vue?vue&type=script&lang=js"
import style0 from "./FloatButtons.vue?vue&type=style&index=0&id=6f2ee956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2ee956",
  null
  
)

export default component.exports